import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `app1/prospects/${path}`;

// Public (no auth) — used by GetStartedPage
export function fetchProspectVerticals() {
  return defaultClient.request({
    url: URL('verticals/'),
    method: 'GET',
    auth: false,
  });
}

export function fetchProspectParentCompany(slug) {
  return defaultClient.request({
    url: URL(`parent-company/${slug}/`),
    method: 'GET',
    auth: false,
  });
}

export function fetchProspectEstimate(payload = {}) {
  return defaultClient.request({
    url: URL('estimate/'),
    method: 'POST',
    payload,
    auth: false,
  });
}

export function fetchProspectZipDemographics(payload = {}) {
  return defaultClient.request({
    url: URL('zip-demographics/'),
    method: 'POST',
    payload,
    auth: false,
  });
}

export function uploadProspectZipFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  return defaultClient.request({
    url: URL('zip-file/'),
    method: 'POST',
    payload: formData,
    auth: false,
  });
}

export function checkProspectZips(zipRows = []) {
  return defaultClient.request({
    url: URL('zip-check/'),
    method: 'POST',
    payload: { zip_rows: zipRows },
    auth: false,
  });
}

export function searchProspectServiceAreas(q) {
  return defaultClient.request({
    url: URL('service-areas/'),
    method: 'GET',
    payload: { q },
    auth: false,
  });
}

export function expandProspectServiceAreas(areas = []) {
  return defaultClient.request({
    url: URL('service-areas/expand/'),
    method: 'POST',
    payload: { areas },
    auth: false,
  });
}

// Contact details from a short application, for /get-started?ref=<token>.
export function fetchShortApplyPrefill(token) {
  return defaultClient.request({
    url: URL(`apply/${encodeURIComponent(token)}/`),
    method: 'GET',
    auth: false,
  });
}

export function submitProspect(payload = {}) {
  return defaultClient.request({
    url: URL('submit/'),
    method: 'POST',
    payload,
    auth: false,
  });
}

// Staff-only
export function listProspects(params = {}) {
  const query = new URLSearchParams();
  if (params.status) query.set('status', params.status);
  if (params.search) query.set('search', params.search);
  const qs = query.toString();
  return defaultClient.request({
    url: URL(qs ? `?${qs}` : ''),
    method: 'GET',
  });
}

export function fetchProspect(token) {
  return defaultClient.request({
    url: URL(`${token}/`),
    method: 'GET',
  });
}

export function updateProspect(token, payload = {}) {
  return defaultClient.request({
    url: URL(`${token}/`),
    method: 'PATCH',
    payload,
  });
}

export function fetchProspectFitReport(token) {
  return defaultClient.request({
    url: URL(`${token}/fit-report/`),
    method: 'GET',
  });
}

export function shareProspectProjections(token) {
  return defaultClient.request({
    url: URL(`${token}/share-projections/`),
    method: 'POST',
  });
}

export function acceptProspect(token) {
  return defaultClient.request({
    url: URL(`${token}/accept/`),
    method: 'POST',
  });
}

// Book one of the prospect's requested call times (Zoom + invite + confirmation).
export function confirmProspectTime(token, startsAt) {
  return defaultClient.request({
    url: URL(`${token}/confirm-time/`),
    method: 'POST',
    payload: { starts_at: startsAt },
  });
}

// attendance: 'showed' | 'no_show' — closes out the latest past discovery call.
export function markProspectAttendance(token, attendance) {
  return defaultClient.request({
    url: URL(`${token}/attendance/`),
    method: 'POST',
    payload: { attendance },
  });
}

export function fetchAcceptAndSendPreview(token) {
  return defaultClient.request({
    url: URL(`${token}/accept-and-send-contract/`),
    method: 'GET',
  });
}

export function acceptAndSendContract(token, { sendBookingEmail = false } = {}) {
  return defaultClient.request({
    url: URL(`${token}/accept-and-send-contract/`),
    method: 'POST',
    payload: { send_booking_email: sendBookingEmail },
  });
}

export function declineProspect(token, reason) {
  return defaultClient.request({
    url: URL(`${token}/decline/`),
    method: 'POST',
    payload: { reason },
  });
}

export function archiveProspect(token) {
  return defaultClient.request({
    url: URL(`${token}/`),
    method: 'PATCH',
    payload: { is_archived: true },
  });
}

export function convertProspect(token) {
  return defaultClient.request({
    url: URL(`${token}/convert/`),
    method: 'POST',
  });
}

export function convertProspectGroup(groupToken) {
  return defaultClient.request({
    url: URL(`group/${groupToken}/convert-all/`),
    method: 'POST',
  });
}
